export default {
  namespaced: true,
  state: {
    information: [],
    error:[]
  },
  mutations:{
    saveInfo(state, messages){
      state.information = messages
    },
    saveError(state, messages){
      state.error = messages
    }
  }
}